import { Trans } from "@lingui/react/macro";
import styles from "./Equipment.module.scss";
import { Outlet, useNavigate, useParams } from "react-router";
import { SplitPane } from "@/components/SplitPane/SplitPane";
import { z } from "zod";
import { FilledButton } from "@medoma/components/Button/Button";
import { AllocatedAssets } from "./AllocatedAssets";

const Equipment = () => {
  const { patientId } = z.object({ patientId: z.string() }).parse(useParams());
  const navigate = useNavigate();

  return (
    <SplitPane panelSizeLocalStorageKey="patient-equipment">
      <div className={styles.equipment}>
        <FilledButton onClick={() => navigate("allocate")}>
          <Trans>Tilldela ny utrustning</Trans>
        </FilledButton>
        <AllocatedAssets patientId={patientId} />
      </div>
      <Outlet />
    </SplitPane>
  );
};

export default Equipment;
